import React, { useState, useCallback, useEffect } from "react";
import "./ComingSoon.css";

// Toast component — rendered once at App level, controlled via hook
export function ComingSoonToast({ visible }) {
  const [leaving, setLeaving] = useState(false);

  useEffect(() => {
    if (!visible) {
      setLeaving(true);
      const t = setTimeout(() => setLeaving(false), 300);
      return () => clearTimeout(t);
    } else {
      setLeaving(false);
    }
  }, [visible]);

  if (!visible && !leaving) return null;

  return (
    <div
      className={`cs-toast ${leaving ? "leaving" : ""}`}
      role="status"
      aria-live="polite"
    >
      <span className="cs-toast-icon">🚀</span>
      <div className="cs-toast-text">
        <strong>Coming Soon</strong>
        <span>We'll notify you at launch</span>
      </div>
    </div>
  );
}

// Hook — call showComingSoon() on any button click, auto-dismisses after 2.8s
export function useComingSoon() {
  const [visible, setVisible] = useState(false);
  const timerRef = React.useRef(null);

  const show = useCallback(() => {
    // Reset timer if already showing
    if (timerRef.current) clearTimeout(timerRef.current);
    setVisible(true);
    timerRef.current = setTimeout(() => setVisible(false), 2800);
  }, []);

  useEffect(
    () => () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    },
    [],
  );

  return { visible, show };
}
